<template></template>
<script>
export default {
    name: "File",
    props : {
        accept : {
            type : Array,
            default() {
                return ['.xlsx'];
            }
        },
        multiple : {
            type : Boolean,
            default() {
                return true;
            }
        }
    },
    methods: {
        showFile() {
            let fileInput = document.createElement('input');

            fileInput.type = 'file';
            fileInput.name = 'file',
            fileInput.multiple = this.multiple,
            fileInput.accept = this.accept.join(', ')

            document.body.appendChild(fileInput);
            fileInput.click();

            // Remove input from the DOM
            fileInput.addEventListener('cancel', () => {
                document.body.removeChild(fileInput);
            });
            fileInput.addEventListener('change', (event) => {
                this.$emit('fileIsSelected', event.target.files);
                document.body.removeChild(fileInput);
            });
        }
    }
}
</script>